import { createElement } from "@wordpress/element";
export default function save(_ref) {
  var attributes = _ref.attributes;
  return createElement("div", {
    style: {
      height: attributes.height
    },
    "aria-hidden": true
  });
}
//# sourceMappingURL=save.js.map